import store from "../redux/app/store";

const getBaseUrl = () => {
  const storeData = store.getState();
  return `${storeData.applicationState.serverAddress}`;
};

const getImageBaseUrl = () => {
  return "";
};

export { getBaseUrl, getImageBaseUrl };
